import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { PageTransition } from "@/components/PageTransition";
import { NavbarV2 } from "@/components/v2/NavbarV2";
import { FooterV2 } from "@/components/v2/FooterV2";
import { StickyCTAV2 } from "@/components/v2/StickyCTAV2";
import { CursorFollower } from "@/components/v2/CursorFollower";
import { SmoothScroll } from "@/components/v2/SmoothScroll";
import { IntroCinematique } from "@/components/v2/IntroCinematique";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Product from "@/pages/Product";
import Sector from "@/pages/Sector";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Gallery from "@/pages/Gallery";
import CatalogueFlip from "@/pages/CatalogueFlip";
import { BlogList, BlogPost } from "@/pages/Blog";
import { LegalMentions, Privacy, Terms } from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/catalogue-feuilletable" element={<PageTransition><CatalogueFlip /></PageTransition>} />
        <Route path="/catalogue" element={<PageTransition><Catalog /></PageTransition>} />
        {/* Dedicated category pages — same Catalog component, slug resolved
            inside via useParams. Public URLs are /catalogue/<url-slug>
            (e.g. /catalogue/frites-surgelees, /catalogue/sauces). Legacy
            /catalogue?categorie=<data-slug> URLs still resolve in Catalog.jsx
            for back-compat (old shares, sitemap warm caches). */}
        <Route path="/catalogue/:categorySlug" element={<PageTransition><Catalog /></PageTransition>} />
        <Route path="/produit/:slug" element={<PageTransition><Product /></PageTransition>} />
        <Route path="/concept/:slug" element={<PageTransition><Sector /></PageTransition>} />
        <Route path="/a-propos" element={<PageTransition><About /></PageTransition>} />
        <Route path="/contact" element={<PageTransition><Contact /></PageTransition>} />
        <Route path="/faq" element={<PageTransition><FAQ /></PageTransition>} />
        <Route path="/galerie" element={<PageTransition><Gallery /></PageTransition>} />
        <Route path="/blog" element={<PageTransition><BlogList /></PageTransition>} />
        <Route path="/blog/:slug" element={<PageTransition><BlogPost /></PageTransition>} />
        <Route path="/mentions-legales" element={<PageTransition><LegalMentions /></PageTransition>} />
        <Route path="/confidentialite" element={<PageTransition><Privacy /></PageTransition>} />
        <Route path="/cgu" element={<PageTransition><Terms /></PageTransition>} />
        {/* Catch-all 404 — must stay last. */}
        <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll>
          <IntroCinematique />
          <CursorFollower />
          <div className="grain-overlay"></div>
          <NavbarV2 />
          <AnimatedRoutes />
          <StickyCTAV2 />
          <FooterV2 />
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
